export const ROUTES = {
  LOGIN: "/login",
  HOME: "/home",
};
